import { render, staticRenderFns } from "./teamTemplate.vue?vue&type=template&id=bba3ec24&scoped=true&"
import script from "./teamTemplate.vue?vue&type=script&lang=js&"
export * from "./teamTemplate.vue?vue&type=script&lang=js&"
import style0 from "./teamTemplate.vue?vue&type=style&index=0&id=bba3ec24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3ec24",
  null
  
)

export default component.exports